import { createSlice } from '@reduxjs/toolkit'

export const TourStepSlice = createSlice({
  name: 'tour_steps',
  initialState: {
    value: {},
  },
  reducers: {
    tourStep: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { tourStep } = TourStepSlice.actions

export default TourStepSlice.reducer